import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import WidgetOptions from './WidgetOptions';
import { configure } from '../../actions/WidgetAction';
import { ResizeElements } from '../../utils/helper';

class AppWidget extends Component {
  onExpandClick(type) {
    this.props.configure(ResizeElements(type));
  }

  render() {
    return (
      <div>
        <div id={this.props.id} className={this.props.class}>
          <div className="box">
            {!this.props.tabs ? (
              <div>
                <div className="box-header with-border">
                  <div className="user-block">
                    <span className="username">{this.props.tabText}</span>
                  </div>
                  <div className="box-tools">
                    <WidgetOptions
                      infoIdText={this.props.infoText}
                      expandIdText={this.props.expandText}
                      onExpandClick={this.onExpandClick.bind(this)}
                      hideExpand={this.props.hideExpand}
                    ></WidgetOptions>
                  </div>
                </div>
                <div className="box-body">{this.props.children}</div>
              </div>
            ) : (
              <div
                className={`box-header with-border ${
                  !this.props.isNormalWidget && 'fitContent'
                }`}
              >
                {this.props.children}
                <div className="box-tools">
                  <WidgetOptions
                    infoIdText={this.props.infoText}
                    expandIdText={this.props.expandText}
                    onExpandClick={this.onExpandClick.bind(this)}
                    hideExpand={this.props.hideExpand}
                  ></WidgetOptions>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

AppWidget.propTypes = {
  children: PropTypes.node.isRequired,
  configure: PropTypes.func,
  infoText: PropTypes.string,
  expandText: PropTypes.string,
  tabText: PropTypes.string,
  class: PropTypes.string,
  id: PropTypes.string,
  tabs: PropTypes.bool,
  isNormalWidget: PropTypes.bool,
  hideExpand: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      configure,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(AppWidget);
